import React from 'react';
import { CheckCircle2Icon, XCircleIcon } from 'lucide-react';
import { afterItems, beforeItems, transformationStats } from '../data/transformation';
import { Reveal } from './Reveal';
export function TransformationSection() {
  return <section className="bg-brand-main px-4 py-20 md:py-28" data-id="element-167" data-mp="2ww2p8roo2zvm">
      <Reveal className="mx-auto max-w-5xl" data-id="element-168" data-mp="2rz2isfnwnv3z">
        <div className="mx-auto max-w-3xl text-center" data-id="element-169" data-mp="2ryayw23o7ltj">
          <p className="mb-4 text-xs font-extrabold tracking-[0.18em] text-brand-coral" data-id="element-170" data-mp="2nx7h3a22bfpo">
            LEPSZY SPOSÓB NA TRENOWANIE SIATKÓWKI
          </p>
          <h2 className="text-4xl font-black uppercase leading-[1.06] tracking-tight text-brand-navy md:text-5xl" data-id="element-171" data-mp="2j4608wiap63g">
            Z przytłoczonego nauczyciela w <span className="italic text-brand-coral" data-id="element-172" data-mp="298ukqbz2buun">pewnego siebie trenera.</span>
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-brand-gray md:text-base" data-id="element-173" data-mp="24985jwzoc4j7">
            Gotowi na Siatkówkę zamienia godziny planowania w jeden gotowy system. Wchodzisz na każdy trening z jasnym
            planem, sensownymi ćwiczeniami i pewnością, że prowadzisz zespół w dobrym kierunku.
          </p>
        </div>

        <div className="mx-auto my-12 grid max-w-3xl divide-y divide-brand-dark overflow-hidden rounded-2xl border border-brand-dark bg-brand-alt shadow-sm sm:grid-cols-3 sm:divide-x sm:divide-y-0" data-id="element-174" data-mp="k33v6r1wji35">
          {transformationStats.map(({
          value,
          label
        }) => <div key={label} className="px-5 py-5 text-center" data-id="element-175" data-mp="y2llxbyrd5f5">
              <strong className="block font-display text-3xl font-black leading-none text-brand-coral" data-id="element-176" data-mp="130n13lt2cklc">{value}</strong>
              <span className="mt-2 block text-[10px] font-extrabold leading-tight tracking-[0.08em] text-brand-gray" data-id="element-177" data-mp="p1f2ov4q5gi7">
                {label}
              </span>
            </div>)}
        </div>

        <div className="overflow-hidden rounded-3xl border border-brand-dark bg-brand-alt shadow-[0_18px_45px_rgba(14,42,71,0.10)]" data-id="element-178" data-mp="39quy63ew1te6">
          <div className="grid md:grid-cols-2" data-id="element-179" data-mp="3du1397q9lej2">
            <Comparison title="PRZED" items={beforeItems} positive={false} data-id="element-180" data-mp="1kaimz0dzotov" />
            <Comparison title="Z GOTOWI NA SIATKÓWKĘ" items={afterItems} positive data-id="element-181" data-mp="1kbtth7ytkfjo" />
          </div>
          <div className="border-t border-brand-dark bg-brand-main px-6 py-4 text-center text-xs font-semibold text-brand-gray" data-id="element-182" data-mp="1fd8s357tzptn">
            Kompletny program treningowy, dzięki któremu przygotowujesz się krócej, a prowadzisz pewniej.
          </div>
        </div>
      </Reveal>
    </section>;
}
function Comparison({
  title,
  items,
  positive
}: {
  title: string;
  items: string[];
  positive: boolean;
}) {
  const Icon = positive ? CheckCircle2Icon : XCircleIcon;
  return <div className={`p-6 md:p-9 ${positive ? 'border-t border-brand-dark bg-brand-alt md:border-l md:border-t-0' : 'bg-[#F4F0EA]'}`} data-id="element-183" data-mp="rlk39yu7xjhg">
      <div className="mb-7 flex items-start justify-between gap-4" data-id="element-184" data-mp="2lz2vct5hc9vd">
        <div data-id="element-185" data-mp="2lx8j0389xq2w">
          <p className={`text-[10px] font-extrabold tracking-[0.16em] ${positive ? 'text-brand-coral' : 'text-brand-gray'}`} data-id="element-186" data-mp="2h08evxuzixef">
            {positive ? 'SYSTEM GOTOWY DO PROWADZENIA' : 'KOSZT ZACZYNANIA OD ZERA'}
          </p>
          <h3 className="mt-2 font-display text-2xl font-black uppercase tracking-tight text-brand-navy" data-id="element-187" data-mp="2thj6k9t3erdw">{title}</h3>
        </div>
        <div className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full ${positive ? 'bg-brand-coral text-white shadow-md' : 'bg-brand-alt text-brand-gray'}`} data-id="element-188" data-mp="2ybnf2xi0b7h3">
          <Icon className="h-5 w-5" aria-hidden="true" data-id="element-189" data-mp="26khbg732urn2" />
        </div>
      </div>
      <ul className="space-y-2.5" data-id="element-190" data-mp="2akhyuh85md69">
        {items.map(item => <li key={item} className={`flex items-center gap-3 rounded-xl px-3 py-3 ${positive ? 'bg-brand-main' : 'bg-brand-alt/70'}`} data-id="element-191" data-mp="2fit8oryg8noh">
            <Icon className={`h-4 w-4 shrink-0 ${positive ? 'text-brand-coral' : 'text-brand-gray'}`} aria-hidden="true" data-id="element-192" data-mp="3qy859umqxdj2" />
            <span className={`text-sm leading-snug ${positive ? 'font-semibold text-brand-text' : 'text-brand-gray'}`} data-id="element-193" data-mp="3vvhrl1eu992o">
              {item}
            </span>
          </li>)}
      </ul>
    </div>;
}